import { GroupOption } from '@/types/metrics'
import { ByTimeMetricReport } from '@/types/workflow-metric-reports'
import ByTimeMetricBarChart from '../ByTimeAndStateMetricBarChart'
import ChartCard from '../ChartCard'
import MetricsStatesFilter, {
  useWorkflowSelectedStateIds,
} from '../MetricsStatesFilter'
import { DateRange } from '../ProjectMetricsDashboard'

type CompletedDocumentsCountCardProps = {
  report?: ByTimeMetricReport
  groupBy: GroupOption
  selectedDateRange: DateRange
}

export default function CompletedDocumentsCountCard({
  report,
  groupBy,
  selectedDateRange,
}: CompletedDocumentsCountCardProps) {
  const {
    allStateIds,
    filteredStateIds,
    selectedStateIds,
    setSelectedStateIds,
  } = useWorkflowSelectedStateIds({
    key: 'doc-completed-count',
    report,
  })

  return (
    <ChartCard
      heading="Completed Documents"
      headingTooltip="The number of documents that entered any “Done” workflow state."
      controls={
        <MetricsStatesFilter
          allStateIds={allStateIds}
          selectedStateIds={selectedStateIds}
          setSelectedStateIds={setSelectedStateIds}
        />
      }
    >
      <ByTimeMetricBarChart
        report={report}
        filteredStateIds={filteredStateIds}
        groupBy={groupBy}
        selectedDateRange={selectedDateRange}
      />
    </ChartCard>
  )
}
